export default __webpack_public_path__ + "static/media/arafa-b.cda65b23.jpeg";